// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__+IHQ2","links":"Footer_links__88goG","link":"Footer_link__eOjUr"};